export function getIsMobile() {
  return (
    typeof window !== 'undefined' &&
    window.matchMedia('(pointer: coarse)').matches &&
    window.matchMedia('(max-width: 767px)').matches
  );
}
